// extracted by mini-css-extract-plugin
module.exports = {"root":"StyleQuizPage_root__XH2kp","title":"StyleQuizPage_title__3T6p7","subTitle":"StyleQuizPage_subTitle__2J7EZ","video":"StyleQuizPage_video__2_8UD"};